// The first session of this device (R2057, ui-map-interface.md §17.3.67).
//
// A new player meets the map with every key open; a player who has seen
// it once meets it with the keys folded to their heads. "This device"
// is the browser: a per-device flag in `localStorage` (`ui/localstore.ts`)
// marks that the game page stood here once, and a flag in `sessionStorage`
// keeps the first session first through a reload of the same tab. A store
// that refuses has no memory, so every session is a first one: the legend
// then opens as it did before R2057.
//
// The legend card reads it once, at its first render. The module imports
// only the store.

import { readStore, writeStore } from './localstore';

/** The device flag: the game page stood in this browser once. */
export const FIRST_SEEN_KEY = 'ap.firstview.seen';
/** The session flag: this tab session is the device's first one. */
export const FIRST_SESSION_KEY = 'ap.firstview.session';

/**
 * Is this the first session, from the two flags as the stores hold them?
 * The session flag wins, so a reload of the first session stays first.
 */
export function firstSessionOf(device: string | null, session: string | null): boolean {
  return session === '1' || device === null;
}

let known: boolean | null = null;

/**
 * Is this the first session of this device? The first call decides and
 * writes both flags in a first session; every later call answers the same.
 */
export function isFirstSession(): boolean {
  if (known !== null) return known;
  known = firstSessionOf(readStore(FIRST_SEEN_KEY), readStore(FIRST_SESSION_KEY, 'session'));
  if (known) {
    writeStore(FIRST_SEEN_KEY, '1');
    writeStore(FIRST_SESSION_KEY, '1', 'session');
  }
  return known;
}

/** Forgets the answer, for a test. */
export function forgetFirstSession(): void {
  known = null;
}
